// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';
// Notifications plugin. Used on Notifications page
import Notifications from '@/components/NotificationPlugin';
// Validation plugin used to validate forms
import { configure } from 'vee-validate';
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents';
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from '@/components/SidebarPlugin';

// element ui language configuration
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);

// asset imports
import '@/assets/sass/argon.scss';
import '@/assets/css/nucleo/css/nucleo.css';
import '@/assets/css/style.css';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

import TranslateID from '@/languages/id';
import TranslateEN from '@/languages/en';
import Translate from '@/helpers/translate';

import Dialog from '@/helpers/dialog';

import Functions from '@/helpers/functions';

import UploadFile from '@/helpers/uploadFile';

let TranslateDefault = 'en';
if (localStorage.getItem('language')) {
  TranslateDefault = localStorage.getItem('language');
}
Translate.setDefaultLanguage(TranslateDefault);
Translate.setDictionary('en', TranslateEN);
Translate.setDictionary('id', TranslateID);

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.mixin({methods: Translate});
    Vue.mixin({methods: Dialog});    
    Vue.mixin({methods: Functions});    
    Vue.mixin({methods: UploadFile});    
    configure({
      classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
      }
    })
  }
};
